var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDemoDotMenu = function SvgIconDemoDotMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    fill: "#CDCCFA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 8.5,
    r: 1.5,
    fill: "#CDCCFA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 15.5,
    r: 1.5,
    fill: "#CDCCFA"
  })));
};
export { SvgIconDemoDotMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjEuNSIgY3k9IjEuNSIgcj0iMS41IiBmaWxsPSIjQ0RDQ0ZBIiBkYXRhLW5vLXN0cm9rZT0iIi8+CiAgICA8Y2lyY2xlIGN4PSIxLjUiIGN5PSI4LjUiIHI9IjEuNSIgZmlsbD0iI0NEQ0NGQSIgZGF0YS1uby1zdHJva2U9IiIvPgogICAgPGNpcmNsZSBjeD0iMS41IiBjeT0iMTUuNSIgcj0iMS41IiBmaWxsPSIjQ0RDQ0ZBIiBkYXRhLW5vLXN0cm9rZT0iIi8+Cjwvc3ZnPgo=";